<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <div class="d-flex justify-content-between">
            <h6 class="element-header">Firmeneinstellungen</h6>
          </div>

          <div class="element-box">
            <form @submit.prevent="submitForm" novalidate>

              <div class="card shadow-sm border-0 mb-4">
                <div class="card-header bg-light border-bottom-0 py-3">
                  <h6 class="mb-0 fw-bold text-secondary">
                    <i class="fa-solid fa-building section-icon"></i>Firmeninformationen
                  </h6>
                </div>

                <div class="card-body">
                  <!-- Company Information -->
                  <div class="row">
                    <div class="col-lg-6 col-md-12 col-sm-12">
                      <BaseInput
                          v-model="formData.name"
                          label="Name"
                          :required="true"
                          :validation="v$?.name"
                          :messages="v$?.name?.required?.$message"/>

                      <!-- Row for City i ZIP -->
                      <div class="row">
                        <div class="col-md-9">
                          <BaseInput
                              v-model="formData.city"
                              label="Stadt"
                              :required="true"
                              :validation="v$?.city"
                              :messages="v$?.city?.required?.$message"/>
                        </div>
                        <div class="col-md-3">
                          <BaseInput
                              v-model="formData.zip"
                              label="PLZ"
                              :required="true"
                              :validation="v$?.zip"
                              :messages="v$?.zip?.required?.$message"/>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6">
                          <BaseInput
                              v-model="formData.email"
                              type="email"
                              :required="true"
                              label="Email"
                              :validation="v$?.email"
                              :messages="v$?.email?.isValidEmail?.$message"/>
                        </div>
                        <div class="col-lg-6">
                          <BaseInput
                              v-model="formData.contactPerson"
                              :required="true"
                              label="Ansprechpartner"
                              :validation="v$?.contactPerson"
                              :messages="v$?.contactPerson?.required?.$message"/>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 col-md-12 col-sm-12">
                      <div class="row">
                        <div class="col-lg-9 col-md-12 col-sm-12">
                          <BaseInput
                              v-model="formData.shortName"
                              label="Kurzname"
                              :required="true"
                              :validation="v$?.shortName"
                              :messages="v$?.shortName?.required?.$message"/>
                        </div>
                        <div class="col-lg-3 col-md-12 col-sm-12">
                          <SelectedDropdown
                              v-model="formData.companyKey"
                              :options="companyKeys"
                              label="Firmen-ID"
                              :required="true"
                              :validation="v$?.companyKey"
                              :messages="v$?.companyKey?.required?.$message"/>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-lg-6 col-md-12 col-sm-12">
                          <BaseInput
                              v-model="formData.address"
                              label="Address"
                              :required="true"
                              :validation="v$?.address"
                              :messages="v$?.address?.required?.$message"/>
                        </div>
                        <div class="col-lg-3 col-md-12 col-sm-12">
                          <BaseInput
                              v-model="formData.houseNumber"
                              label="Hausnummer"
                              :required="true"
                              :validation="v$?.houseNumber"
                              :messages="v$?.houseNumber?.required?.$message"/>
                        </div>
                        <div class="col-lg-3 col-md-12 col-sm-12">
                          <BaseInput
                              v-model="formData.country"
                              :required="true"
                              label="Land"
                              :validation="v$?.country"
                              :messages="v$?.country?.required?.$message"/>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-lg-6 col-md-12 col-sm-12">
                          <BaseInput
                              v-model="formData.website"
                              label="Website"
                              :required="true"
                              :validation="v$?.website"
                              :messages="v$?.website?.required?.$message"/>
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12">
                          <BaseInput
                              :required="true"
                              v-model="formData.phoneNumber"
                              label="Telefonnummer"
                              :validation="v$?.phoneNumber"
                              :messages="v$?.phoneNumber?.required?.$message"/>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseInput
                          v-model="formData.registrationPlace"
                          :required="true"
                          label="Handelsregister (Ort)"
                          :validation="v$?.registrationPlace"
                          :messages="v$?.registrationPlace?.required?.$message"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseInput
                          v-model="formData.registrationCourt"
                          :required="true"
                          label="Registergericht"
                          :validation="v$?.registrationCourt"
                          :messages="v$?.registrationCourt?.required?.$message"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseInput
                          v-model="formData.registrationNumber"
                          :required="true"
                          label="Handelsregisternummer"
                          :validation="v$?.registrationNumber"
                          :messages="v$?.registrationNumber?.required?.$message"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseInput
                          v-model="formData.instituteIdentifier"
                          :required="true"
                          label="Institutskennzeichen"
                          :validation="v$?.instituteIdentifier"
                          :messages="v$?.instituteIdentifier?.required?.$message"/>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseInput
                          :required="true"
                          v-model="formData.managingDirector1"
                          label="Geschäftsführer 1"
                          :validation="v$?.managingDirector1"
                          :messages="v$?.managingDirector1?.required?.$message"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseInput
                          v-model="formData.managingDirector2"
                          label="Geschäftsführer 2"
                          :validation="v$?.managingDirector2"
                          :messages="v$?.managingDirector2?.required?.$message"/>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card shadow-sm border-0 mb-4">
                <div class="card-header bg-light border-bottom-0 py-3">
                  <h6 class="mb-0 fw-bold text-secondary">
                    <i class="fa-solid fa-landmark section-icon"></i>Finanzielle und steuerliche Details
                  </h6>
                </div>
                <div class="card-body">
                  <div class="row align-items-start">
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseInput
                          :required="true"
                          v-model="formData.bank"
                          label="Bank"
                          :validation="v$?.swift"
                          :messages="v$?.swift?.bank?.$message"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseInput
                          :required="true"
                          v-model="formData.swift"
                          label="SWIFT/BIC"
                          :validation="v$?.swift"
                          :messages="v$?.swift?.required?.$message"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseInput
                          :required="true"
                          v-model="formData.iban"
                          label="IBAN"
                          :validation="v$?.iban"
                          :messages="v$?.iban?.required?.$message"/>
                    </div>

                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseInput
                          v-model="formData.taxNumber"
                          :required="true"
                          label="Steuernummer"
                          :validation="v$?.taxNumber"
                          :messages="v$?.taxNumber?.required?.$message"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseInput
                          :required="true"
                          v-model="formData.accountingContactPerson"
                          label="Ansprechpartner für die Buchhaltung"
                          :validation="v$?.accountingContactPerson"
                          :messages="v$?.accountingContactPerson?.required?.$message"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseInput
                          v-model="formData.accountingPhoneNumber"
                          label="Telefonnummer der Buchhaltung"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseInput
                          v-model="formData.accountingEmail"
                          label="Buchhaltungs-E-Mail"/>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card shadow-sm border-0 mb-4">
                <div class="card-header bg-light border-bottom-0 py-3">
                  <h6 class="mb-0 fw-bold text-secondary">
                    <i class="fa-solid fa-palette section-icon"></i>Firmenlogo und Farbe
                  </h6>
                </div>

                <div class="card-body">
                  <div class="form-row align-items-start">

                    <div class="col-12 col-md-6 col-lg-3 mb-3">
                      <label class="font-weight-bold">Firmenlogo</label>
                      <BaseDropzoneImage
                          v-model="logo"
                          :multiple="false"
                          :height="200"
                          text="Firmenlogo hochladen."
                          style="width: 100%; max-width: 300px; margin: 0 auto;"
                          class="dropzone-image"/>
                    </div>

                    <div class="col-12 col-md-6 col-lg-3 mb-3">
                      <label class="font-weight-bold">Vorschau</label>
                      <div class="logo-preview d-flex justify-content-center align-items-center rounded"
                           style="width: 100%; height: 200px; max-height: 200px; overflow: hidden; border: 1px solid rgba(0, 0, 0, 0.15); background-color: #f8f9fa;">
                        <img
                            v-if="formData.logoUrl"
                            :src="formData.logoUrl"
                            alt="Company Logo"
                            class="p-2"
                            style="max-width: 100%; max-height: 100%; object-fit: contain;"/>
                        <span v-else class="text-muted small">Kein Logo geladen</span>
                      </div>
                    </div>

                    <div class="col-12 col-md-4 col-lg-2 mb-3 d-flex flex-column align-items-center text-center">
                      <BaseColorPicker
                          v-model="formData.colorCode"
                          label="Firmenfarbe"
                          :required="true"/>
                    </div>

                    <div class="col-12 col-md-8 col-lg-4 mb-3">
                      <div class="p-3 rounded border" style="background-color: rgba(0, 0, 0, 0.02); border-color: rgba(0, 0, 0, 0.1) !important;">

                        <div class="text-muted mb-3 small font-weight-bold text-uppercase" style="letter-spacing: 0.5px;">
                          <i class="os-icon os-icon-layout mr-1"></i> Menü-Einstellungen (Sidebar)
                        </div>

                        <div class="form-row">
                          <div class="col-12 col-sm-4 mb-2 mb-sm-0">
                            <BaseColorPicker
                                v-model="formData.sidebarColorCode"
                                label="Menüfarbe"
                                :required="true"/>
                          </div>
                          <div class="col-12 col-sm-4 mb-2 mb-sm-0">
                            <BaseColorPicker
                                v-model="formData.sidebarIconColorCode"
                                label="Symbolfarbe"
                                :required="true"/>
                          </div>
                          <div class="col-12 col-sm-4">
                            <BaseColorPicker
                                v-model="formData.sidebarLinkColorCode"
                                label="Linkfarbe"
                                :required="true"/>
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div class="card shadow-sm border-0 mb-4">
                <div class="card-header bg-light border-bottom-0 py-3">
                  <h6 class="mb-0 fw-bold text-secondary">
                    <i class="fa-solid fa-toggle-on section-icon"></i>Module
                  </h6>
                </div>

                <div class="card-body p-4">
                  <div class="row align-items-start">
                    <div class="col-lg-2 col-md-4 col-sm-6">
                      <BaseCheckbox
                          v-model="formData.calendarEnabled"
                          label="Calendar"/>
                    </div>
                    <div class="col-lg-2 col-md-4 col-sm-6">
                      <BaseCheckbox
                          v-model="formData.timeManagementEnabled"
                          label="Time Management"/>
                    </div>
                    <div class="col-lg-2 col-md-4 col-sm-6">
                      <BaseCheckbox
                          v-model="formData.clientEnabled"
                          label="Kostenträger"/>
                    </div>
                    <div class="col-lg-2 col-md-4 col-sm-6">
                      <BaseCheckbox
                          v-model="formData.locationEnabled"
                          label="Standorte"/>
                    </div>
                    <div class="col-lg-2 col-md-4 col-sm-6">
                      <BaseCheckbox
                          v-model="formData.userEnabled"
                          label="Mitarbeiter"/>
                    </div>
                    <div class="col-lg-2 col-md-4 col-sm-6">
                      <BaseCheckbox
                          v-model="formData.unemployedEnabled"
                          label="Kuunden"/>
                    </div>
                    <div class="col-lg-2 col-md-4 col-sm-6">
                      <BaseCheckbox
                          v-model="formData.travelExpensesEnabled"
                          label="Fahrtkosten"/>
                    </div>
                    <div class="col-lg-2 col-md-4 col-sm-6">
                      <BaseCheckbox
                          v-model="formData.addressBookEnabled"
                          label="Kontakte"/>
                    </div>
                    <div class="col-lg-2 col-md-4 col-sm-6">
                      <BaseCheckbox
                          v-model="formData.analyticsEnabled"
                          label="Auswertung"/>
                    </div>
                    <div class="col-lg-2 col-md-4 col-sm-6">
                      <BaseCheckbox
                          v-model="formData.deletedRecordsEnabled"
                          label="Gelöschte Datensätze"/>
                    </div>
                    <div class="col-lg-2 col-md-4 col-sm-6">
                      <BaseCheckbox
                          v-model="formData.aiDocumentScanEnabled"
                          label="AI Dokumentenscan"/>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card shadow-sm border-0 mb-4">
                <div class="card-header bg-light border-bottom-0 py-3">
                  <h6 class="mb-0 fw-bold text-secondary">
                    <i class="fa-solid fa-list-check section-icon"></i>Maßnahmenn
                  </h6>
                </div>

                <div class="card-body p-4">
                  <div class="row align-items-start">
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseCheckbox
                          v-model="formData.privateCoachingEnabled"
                          label="Einzelcoaching-Maßnahmenn"/>
                      <BaseInput
                          v-if="formData.privateCoachingEnabled"
                          v-model="formData.privateCoachingEmail"
                          type="email"
                          placeholder="Einzelcoaching Email"
                          :validation="v$?.privateCoachingEmail"
                          :messages="v$?.privateCoachingEmail?.required?.$message"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseCheckbox
                          v-model="formData.groupCoachingEnabled"
                          label="Gruppen Maßnahmen"/>
                      <BaseInput
                          v-if="formData.groupCoachingEnabled"
                          v-model="formData.groupCoachingEmail"
                          type="email"
                          placeholder="Gruppen Maßnahmen Email"
                          :validation="v$?.groupCoachingEmail"
                          :messages="v$?.groupCoachingEmail?.required?.$message"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseCheckbox
                          v-model="formData.socioTherapyCoachingEnabled"
                          label="Soziotherapie Maßnahmen"/>
                      <BaseInput
                          v-if="formData.socioTherapyCoachingEnabled"
                          v-model="formData.socioTherapyCoachingEmail"
                          type="email"
                          placeholder="Soziotherapie Maßnahmen Email"
                          :validation="v$?.socioTherapyCoachingEmail"
                          :messages="v$?.socioTherapyCoachingEmail?.required?.$message"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseCheckbox
                          v-model="formData.privateLearningCoachingEnabled"
                          label="Private Weiterbildungen"/>
                      <BaseInput
                          v-if="formData.privateLearningCoachingEnabled"
                          v-model="formData.privateLearningCoachingEmail"
                          type="email"
                          placeholder="Private Weiterbildungen Email"
                          :validation="v$?.privateLearningCoachingEmail"
                          :messages="v$?.privateLearningCoachingEmail?.required?.$message"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseCheckbox
                          v-model="formData.assistedLivingCoachingEnabled"
                          label="Betreutes Wohnen"/>
                      <BaseInput
                          v-if="formData.assistedLivingCoachingEnabled"
                          v-model="formData.assistedLivingCoachingEmail"
                          type="email"
                          placeholder="Betreutes Wohnen Email"
                          :validation="v$?.assistedLivingCoachingEmail"
                          :messages="v$?.assistedLivingCoachingEmail?.required?.$message"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                      <BaseCheckbox
                          v-model="formData.caseManagementCoachingEnabled"
                          label="DRV Fallmanagement"/>
                      <BaseInput
                          v-if="formData.caseManagementCoachingEnabled"
                          v-model="formData.caseManagementCoachingEmail"
                          type="email"
                          placeholder="DRV Fallmanagement Email"
                          :validation="v$?.caseManagementCoachingEmail"
                          :messages="v$?.caseManagementCoachingEmail?.required?.$message"/>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card shadow-sm border-0 mb-4">
                <div class="card-header bg-light border-bottom-0 py-3">
                  <h6 class="mb-0 fw-bold text-secondary">
                    <i class="fa-solid fa-file-invoice section-icon"></i>Rechnungslegung
                  </h6>
                </div>

                <div class="card-body p-4">
                  <div class="row align-items-start">
                    <div class="col-lg-2 col-md-4 col-sm-6">
                      <BaseCheckbox
                          v-model="formData.billingEnabled"
                          label="Rechnungslegung"/>
                    </div>
                    <div class="col-lg-2 col-md-4 col-sm-6">
                      <BaseCheckbox
                          v-model="formData.coachBillingEnabled"
                          label="Externe Coachabrechnung"/>
                    </div>
                  </div>
                </div>
              </div>

              <ValidationErrorMessage :validationErrors=v$?.$errors></ValidationErrorMessage>

              <div class="form-buttons-w text-center mt-5">
                <SaveButton
                    :label="$t('general.button.save')"
                    :loading="isSubmitting"/>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, onMounted, ref, watch} from 'vue';
import {useVuelidate} from '@vuelidate/core';
import {isValidEmail, requiredRule} from '@/shared/validators/validationRules';
import {ErrorToast, SuccessToast} from '@/components/VueToast';
import companySettingsService from '@/api/CompanySettings/index';
import SaveButton from '@/components/button/SaveButton.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseDropzoneImage from "@/components/base/BaseDropzoneImage.vue";
import {ICompanySettings} from "@/interfaces/CompanySettings/ICompanySettings";
import {useI18n} from "vue-i18n";
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";
import BaseColorPicker from "@/components/BaseColorPicker.vue";
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import SelectedDropdown from "@/components/SelectDropdown.vue";
import ValidationErrorMessage from "@/components/ValidationErrorMessage.vue";
import {piniaEnumsStore} from "@/store/piniaEnumsStore";

const {t} = useI18n();
const logo = ref<File[]>([])

const piniaEnumsState = piniaEnumsStore();
const {companyKeys} = computed(() => piniaEnumsState.enums).value;

const formData = ref<ICompanySettings>({
  //----- Company information -----
  name: '',
  shortName: '',
  companyKey: '',
  address: '',
  houseNumber: '',
  city: '',
  zip: '',
  country: '',
  email: '',
  contactPerson: '',
  website: '',
  phoneNumber: '',
  managingDirector1: '',
  managingDirector2: '',

  registrationPlace: '',
  registrationCourt: '',
  registrationNumber: '',
  instituteIdentifier: '',

  taxNumber: '',
  iban: '',
  swift: '',
  bank: '',
  accountingContactPerson: '',
  accountingEmail: '',
  accountingPhoneNumber: '',
  logoUrl: '',
  logoFile: null,
  colorCode: '',
  sidebarColorCode: '',
  sidebarIconColorCode: '',
  sidebarLinkColorCode: '',


  //----- Modules -----
  // client
  clientEnabled: false,
  subClientEnabled: false,

  // locations
  locationEnabled: false,

  // course
  coursePrivateCoachingEnabled: false,
  courseGroupCoachingEnabled: false,
  coursePrivateLearningCoachingEnabled: false,
  courseAssistedLivingCoachingPriceEnabled: false,
  courseSocioTherapyCoachingPriceEnabled: false,

  // coaching
  privateCoachingEnabled: false,
  privateCoachingEmail: '',
  groupCoachingEnabled: false,
  groupCoachingEmail: '',
  privateLearningCoachingEnabled: false,
  privateLearningCoachingEmail: '',
  assistedLivingCoachingEnabled: false,
  assistedLivingCoachingEmail: '',
  socioTherapyCoachingEnabled: false,
  socioTherapyCoachingEmail: '',
  caseManagementCoachingEnabled: false,
  caseManagementCoachingEmail: '',

  // billing
  billingEnabled: false,
  coachBillingEnabled: false,

  unemployedEnabled: false,
  analyticsEnabled: false,
  calendarEnabled: false,
  timeManagementEnabled: false,
  holidayEnabled: false,
  travelExpensesEnabled: false,
  userEnabled: false,
  addressBookEnabled: false,
  aiDocumentScanEnabled: false,
  deletedRecordsEnabled: false
});

const rules = ref<Record<string, any>>({
  name: requiredRule(t),
  shortName: requiredRule(t),
  companyKey: requiredRule(t),
  address: requiredRule(t),
  houseNumber: requiredRule(t),
  city: requiredRule(t),
  zip: requiredRule(t),
  country: requiredRule(t),
  email: isValidEmail(t),
  contactPerson: requiredRule(t),
  website: requiredRule(t),
  phoneNumber: requiredRule(t),
  managingDirector1: requiredRule(t),
  accountingContactPerson: requiredRule(t),
  registrationNumber: requiredRule(t),
  registrationPlace: requiredRule(t),
  registrationCourt: requiredRule(t),
  taxNumber: requiredRule(t),
  iban: requiredRule(t),
  swift: requiredRule(t),
  bank: requiredRule(t),
  instituteIdentifier: requiredRule(t)
});

const computedRules = computed(() => rules.value);
const v$ = useVuelidate(computedRules, formData);

const isSubmitting = ref(false);


async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) return;

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    const uploadData = new FormData();

    uploadData.append('body', JSON.stringify(formData.value));

    if (logo.value) {
      uploadData.append('logo', logo.value[0]);
    }

    logo.value = [];
    await companySettingsService.saveSettings(uploadData);
    await loadSettings(true);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function loadSettings(refreshPiniaState: boolean = false) {
  try {
    const {data} = await companySettingsService.getSettings();
    formData.value = {
      ...({} as ICompanySettings),
      ...data?.data,
      colorCode: data?.data?.colorCode ?? '#1b55e2',
      sidebarColorCode: data?.data?.sidebarColorCode ?? '#293145',
      sidebarIconColorCode: data?.data?.sidebarIconColorCode ?? '#293145',
      logoUrl: data?.data?.logoUrl ?? ''
    };

    if (data?.data?.logoUrl) {
      formData.value.logoUrl = data?.data?.logoUrl;
    }

    if (refreshPiniaState) {
      const store = piniaCompanySettingsStore();
      store.companySettings = {...data.data};
    }
  } catch (error) {
    await ErrorToast(error);
  }
}


watch(logo, (newFiles) => {
  const file = newFiles?.[0] || null
  if (!file) return

  const allowedFormats = ['image/jpeg', 'image/jpg', 'image/png']
  if (!allowedFormats.includes(file.type)) {
    logo.value = []
    const toastObj = {
      response: {
        data: {
          error: {
            message: ['Zulässige Bildformate sind: JPG, JPEG, PNG']
          }
        }
      }
    };
    ErrorToast(toastObj)
  }
})


watch(() => formData.value.privateCoachingEnabled, (val) => {
  if (!val) {
    formData.value.privateCoachingEmail = null
    rules.value = {...rules.value, privateCoachingEmail: ''};
  } else {
    // rules.value = {...rules.value, privateCoachingEmail: requiredRule(t)};
  }
})

watch(() => formData.value.groupCoachingEnabled, (val) => {
  if (!val) {
    formData.value.groupCoachingEmail = null
    rules.value = {...rules.value, groupCoachingEmail: ''};
  } else {
    // rules.value = {...rules.value, groupCoachingEmail: requiredRule(t)};
  }
})

watch(() => formData.value.socioTherapyCoachingEnabled, (val) => {
  if (!val) {
    formData.value.socioTherapyCoachingEmail = null
    rules.value = {...rules.value, socioTherapyCoachingEmail: ''};
  } else {
    // rules.value = {...rules.value, socioTherapyCoachingEmail: requiredRule(t)};
  }
})

watch(() => formData.value.privateLearningCoachingEnabled, (val) => {
  if (!val) {
    formData.value.privateLearningCoachingEmail = null
    rules.value = {...rules.value, privateLearningCoachingEmail: ''};
  } else {
    // rules.value = {...rules.value, privateLearningCoachingEmail: requiredRule(t)};
  }
})

watch(() => formData.value.assistedLivingCoachingEnabled, (val) => {
  if (!val) {
    formData.value.assistedLivingCoachingEmail = null
    rules.value = {...rules.value, assistedLivingCoachingEmail: ''};
  } else {
    // rules.value = {...rules.value, assistedLivingCoachingEmail: requiredRule(t)};
  }
})

watch(() => formData.value.caseManagementCoachingEnabled, (val) => {
  if (!val) {
    formData.value.caseManagementCoachingEmail = null
    rules.value = {...rules.value, caseManagementCoachingEmail: ''};
  } else {
    // rules.value = {...rules.value, caseManagementCoachingEmail: requiredRule(t)};
  }
})

onMounted(() => {
  loadSettings();
});
</script>

<style scoped>
.card {
  transition: box-shadow 0.2s ease;
}

.card-header {
  position: relative;
}

.card-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 20px;
  width: 40px;
  height: 2px;
  background: var(--primary);
  border-radius: 2px;
}

.card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.section-icon {
  color: var(--primary);
  margin-right: 8px;
  width: 16px;
  text-align: center;
}

img {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
}

.logo-preview {
  width: 100%;
  height: 200px;
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
}

.dropzone-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>